import { render, staticRenderFns } from "./addVideo.vue?vue&type=template&id=c14acb10&scoped=true"
import script from "./addVideo.vue?vue&type=script&lang=js"
export * from "./addVideo.vue?vue&type=script&lang=js"
import style0 from "./addVideo.vue?vue&type=style&index=0&id=c14acb10&prod&scoped=true&lang=css"
import style1 from "./addVideo.vue?vue&type=style&index=1&id=c14acb10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14acb10",
  null
  
)

export default component.exports